// @flow
import { css } from "styled-components";
import { Link } from "react-router-dom";
import { media } from "@nested/brand";
import {
  NestedLogo,
  Trustpilot,
  TrustpilotStacked,
} from "@nested/brand/src/icons";
import { getImage } from "@nested/utils";

const navigationStyle = css`
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 5px 0px;
  ${media.tablet`
    padding: 15px 10px;
    height: 80px;
  `}
`;

const logoStyle = css`
  margin-left: 10px;
  height: 29px;
  ${media.tablet`
    height: 32px;
    width: 130.7px;
    margin-left: 0;
  `};
`;

const trustpilotWrapper = css`
  display: flex;
  margin-right: 10px;
  align-items: flex-end;
`;

const trustPilotStars = css`
  display: none;

  ${media.tablet`
    display: block;
    height: 23px;
    margin-right: 14px;
  `};
`;

const trustPilotLogo = css`
  display: none;

  ${media.tablet`
    display: block;
    height: 24px;
    width: 103px;
  `};
`;

export const Navigation = () => (
  <nav css={navigationStyle}>
    <Link to="/">
      <NestedLogo css={logoStyle} />
    </Link>
    <a
      href="https://uk.trustpilot.com/review/www.nested.com"
      css={trustpilotWrapper}
      target="_blank"
    >
      <img
        alt="Five stars"
        css={trustPilotStars}
        src={getImage("icons/Trustpilot_ratings_5star-RGB.png")}
      />
      <Trustpilot fill="#000000" css={trustPilotLogo} />
      <TrustpilotStacked
        css={css`
          ${media.tablet`
            display: none;
          `};
        `}
      />
    </a>
  </nav>
);
